<template>
  <main-container>
    <a-card>管理权限</a-card>
  </main-container>
</template>

<script>
export default {
  name: 'SettingAuthority',
  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped></style>
